import axios from "/src/axios.js";

export async function getGoalsExamsSubjects(filterLm, {allowEmpty = false} = {}) {
  try {
    const url = `https://preprodms.embibe.com/coobo_ms/goal-exams-subject${filterLm ? `?${allowEmpty ? '' : 'ignore-empty=true'}&powerschool=true` : ''}`;
    const response = await axios.get(url);
    return Promise.resolve(response.data || {});
  } catch (error) {
    return Promise.reject(error);
  }
}

